import type { FlaggedContentStatus } from "@/react/types/FlaggedContent";
import {
  reactQueryGet,
  reactQueryPatch,
  reactQueryPost,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { UseModerationSettingsInfiniteQueryProps } from "./interfaces";

export interface ApiResource {
  id?: string;
  params?: UseModerationSettingsInfiniteQueryProps;
}

export const useModerationApi = () => {
  const list = ({ params = {} }: ApiResource) =>
    reactQueryGet(internalApi.flaggedContent.index({ params }));

  const exportCsv = (status: FlaggedContentStatus) =>
    reactQueryPost(internalApi.flaggedContent.exportCsv(status));

  const get = (id: string) =>
    reactQueryGet(internalApi.flaggedContent.show({ id }));

  const approve = (id: string) =>
    reactQueryPatch(internalApi.flaggedContent.approve({ id }));

  const reject = (id: string, reason: string | null) =>
    reactQueryPatch(internalApi.flaggedContent.reject({ id }), {
      action_reason_body: reason,
    });

  return {
    list,
    exportCsv,
    get,
    approve,
    reject,
  };
};
